export default function (doc) {
  switch (doc.type) {
    case 'project': return '/projects/' + doc.uid
    case 'page': return '/' + doc.uid
    default: return '/'
  }
}
